import { toast } from "react-toastify";

import { confirmDialog } from "primereact/confirmdialog";

import { ActionUser } from "@/modules/profile/components/ModalUser";
import { useDeleteAgency } from "@/modules/profile/hooks/agency.hooks";
import { useDeleteGroup } from "@/modules/profile/hooks/group.hooks";
import { useDeleteTeam } from "@/modules/profile/hooks/team.hooks";
import {
  useDeleteUser,
  useDetachUserFromTeam,
} from "@/modules/profile/hooks/user.hooks";

import { ManagementType, RemoveEntityModalProps } from "../types/commonTypes";

export const useEntityRemovalManagementModal = () => {
  const { mutate: deleteGroup } = useDeleteGroup({
    handleSuccess: () => toast.success("Le groupe à été supprimé"),
    handleError: () =>
      toast.error(
        "Le groupe n'a pas été supprimé. Vérifiez qu'il ne contient plus d'agences"
      ),
  });

  const { mutate: deleteAgency } = useDeleteAgency({
    handleSuccess: () => toast.success("L'agence à été supprimée"),
    handleError: () =>
      toast.error(
        "L'agence n'a pas été supprimée. Vérifiez qu'elle ne contient plus d'équipes"
      ),
  });

  const { mutate: deleteTeam } = useDeleteTeam({
    handleSuccess: () => toast.success("L'équipe à été supprimée"),
    handleError: () =>
      toast.error(
        "L'équipe n'a pas été supprimée. Vérifiez qu'elle ne contient plus d'utilisateurs"
      ),
  });

  const { mutate: detachUserFromTeam } = useDetachUserFromTeam({
    handleSuccess: () => {
      toast.success("L'utilisateur à été détaché de son équipe");
    },
    handleError: () => {
      toast.error("L'utilisateur n'a pas pu être détaché de son équipe.");
    },
  });

  const { mutate: deleteUser } = useDeleteUser({
    handleSuccess: () => {
      toast.success("L'utilisateur à été supprimé");
    },
    handleError: (error) => {
      toast.error("L'utilisateur n'a pas pu être supprimé");
      console.error(error);
    },
  });

  const removeEntity = (
    id: string,
    userType: ManagementType,
    actionType: ActionUser,
    teamId?: string
  ) => {
    switch (userType) {
      case ManagementType.GROUP:
        deleteGroup(id);
        break;
      case ManagementType.AGENCY:
        deleteAgency(id);
        break;
      case ManagementType.TEAM:
        deleteTeam(id);
        break;
      case ManagementType.USER:
        if (actionType === "detach" && teamId) {
          detachUserFromTeam({ id, teamId });
        } else {
          deleteUser(id);
        }
        break;
    }
  };

  const handleRemoveEntityModal = ({
    id,
    teamId,
    userType,
    actionType,
    label,
  }: RemoveEntityModalProps) => {
    confirmDialog({
      message:
        userType === ManagementType.USER && actionType === "detach"
          ? `Voulez vous détacher ${label} de son équipe ?`
          : `Voulez vous supprimer ${label} ?`,
      header:
        actionType === "detach"
          ? "Confirmation de détachement"
          : "Confirmation de suppression",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => removeEntity(id, userType, actionType, teamId),
    });
  };

  return {
    handleRemoveEntityModal,
  };
};
